<template>
	<div class="session-wrapper">
		<div class="session-left">
			<session-slider-widget></session-slider-widget>
		</div>
		<div class="session-right text-xs-center">
			<div class="session-table-cell pt-4">
				<div class="session-content">
					<img
						:src="appLogo"
						class="img-responsive mb-3"
						width="210"
					/>
					<div v-if="entidadData">
						<h2 class="mb-0">{{entidadData.nombre}}</h2>
						<p class="fs-14">{{entidadData.identificacion}}</p>
					</div>

					<p class="fs-14">{{$t('message.enterUsernameAndPasswordToAccessControlPanelOf')}} {{brand}}.</p>
					<v-form @submit.prevent="submit" class="mb-4">
						<v-text-field
							label="Correo electrónico"
							v-model="email"
							name="email"
							v-validate="'required|email'"
							:error-messages="errors.collect('email')"
							data-vv-as="Correo electrónico"
						></v-text-field>
						<v-text-field
							label="Contraseña"
							v-model="password"
							type="password"
							name="password"
							v-validate="'required'"
							:error-messages="errors.collect('password')"
							data-vv-as="Contraseña"
						></v-text-field>
						<v-checkbox
							color="primary"
							label="Recordar mis credenciales"
							v-model="checkbox"
						></v-checkbox>
						<router-link class="mb-1" to="/session/forgot-password">{{$t('message.forgotPassword')}}?</router-link>
						<div>
							<v-btn large type="submit" @click="submit" :disabled="loadingSesion" :loading="loadingSesion" block color="primary">{{$t('message.loginNow')}}</v-btn>
							<v-btn large @click="onCreateAccount" :disabled="loadingSesion" block color="warning">{{$t('message.createAccount')}}</v-btn>
						</div>
						<p>{{$t('message.bySigningUpYouAgreeTo')}} {{brand}}</p>
						<router-link to="">{{$t('message.termsOfService')}}</router-link>
					</v-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SessionSliderWidget from 'Components/Widgets/SessionSlider'
import AppConfig from 'Constants/AppConfig'
import Axios from 'axios'

export default {
  components: {
    SessionSliderWidget
  },
    data: () => ({
        loadingSesion: false,
        checkbox: false,
        email: null,
        password: null,
        appLogo: AppConfig.appLogo2,
        brand: AppConfig.brand,
		entidadData: null
  }),
  methods: {
    submit() {
      const user = {
        email: this.email,
        password: this.password
      }
        this.$validator.validateAll().then(result => {
            if (result) {
                this.loadingSesion = true
                this.$store.dispatch('signinUser', {user})
					.catch(e => {
                        this.loadingSesion = false
                        this.$store.commit('snackbar', {color: 'error', message: `al iniciar sesión`, error: e})
					})
			}
        })
    },
    onCreateAccount() {
      this.$router.push('/session/sign-up')
    },
	  getEntidadData(){
		  this.loadingSesion = true
    		Axios.get('/empresa_data').then(response => {
				this.loadingSesion = false
				this.entidadData = response.data
		}).catch(error => {
				window.location.href = 'https://easymipres.com'

		})
	  }
  },
  created() {
  	this.getEntidadData()
  }
}
</script>
